var exports = {
  "Q": "MilestoneFilterItem__EyTlmn",
  "G": "MilestoneItem__RvA-sa",
};

module.exports = exports;
